export enum FoodCostRangeLoadingState {
  success = 'success',
  error = 'error',
  loading = 'loading',
}

export enum CostReportCardEllipsisModalModes {
  delete = 'delete',
}
